import { sharedTypes } from './constants';

import type { Event, LoginResponse } from '../types';

export function setAudioOn(audioOn: boolean) {
	return {
		type: sharedTypes.SET_AUDIO_ON,
		payload: {
			audioOn,
		},
	};
}

export function sendEventRequest(data: Event) {
	return {
		type: sharedTypes.SEND_EVENT_REQUEST,
		payload: { data },
	};
}

export function loginRequest() {
	return {
		type: sharedTypes.LOGIN_REQUEST,
	};
}

export function loginSuccess(data: LoginResponse) {
	return {
		type: sharedTypes.LOGIN_SUCCESS,
		payload: { data },
	};
}

export function loginError(error?: string) {
	return {
		type: sharedTypes.LOGIN_ERROR,
		payload: { error },
	};
}

export function sendEventSuccess(data: Record<string, unknown>) {
	return {
		type: sharedTypes.SEND_EVENT_SUCCESS,
		payload: { data },
	};
}

export function sendEventError() {
	return {
		type: sharedTypes.SEND_EVENT_ERROR,
	};
}
